export default __webpack_public_path__ + "static/media/template_business-man__0014_13---PatMadden.d6f30ed1.png";